var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 14",
    width: 21,
    height: 14,
    style: {
      enableBackground: "new 0 0 21 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#555555;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,1h11.4c0.3,0,0.5-0.2,0.5-0.5S12.1,0,11.9,0H0.5C0.2,0,0,0.2,0,0.5S0.2,1,0.5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,4.6h11.4c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H0.5C0.2,3.6,0,3.9,0,4.1S0.2,4.6,0.5,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,7.2H0.5C0.2,7.2,0,7.4,0,7.7s0.2,0.5,0.5,0.5h6.2C7,8.2,7.2,8,7.2,7.7S7,7.2,6.7,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,7.2h-5.3V1.9c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v5.3H9c-0.3,0-0.5,0.2-0.5,0.5S8.7,8.2,9,8.2h5.3 v5.3c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V8.2h5.3C20.8,8.2,21,8,21,7.7S20.8,7.2,20.5,7.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0bc1b3e59d54b777809fbfc56898083e.svg";
export { ForwardRef as ReactComponent };